module.exports = __webpack_public_path__ + "static/gcspin-429068e074c33128e2cd13d1c9e80f0b.gif";